<template>
    <div>
        <v-row>
            <v-col cols="6">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col style="height: 40px" cols="12" sm="4" md="4" lg="4">
                                <h4 style="color: #509bb0">
                                    {{ $i18n.t("Client Revenue") }}
                                </h4>
                            </v-col>
                            <v-col style="height: 28px" cols="12" sm="4" md="4" lg="4" @select="isClient == true">
                                <z-client-select v-model="client" :selectFirst="true"></z-client-select>
                            </v-col>
                            <v-col cols="12" sm="4" md="4" lg="4" style="height: 28px; padding-left: 0px">
                                <z-month-picker style="color: red" :label="''" dense v-model="tillYearMonth" />
                            </v-col>
                        </v-row>
                        <v-row v-if="clientValue">
                            <v-col>
                                <z-spark-line customLabel="true" :value="clientValue" :labels="clientLabel" width="1"
                                    radius="5" lineCap="round" :gradient="clientGradient"></z-spark-line>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="6">
                <v-card class="mx-auto text-center">
                    <v-card-text>
                        <v-row>
                            <v-col style="height: 40px" cols="12" sm="4" md="4" lg="4">
                                <h4 style="color: #509bb0">
                                    {{ $i18n.t("Vendor Revenue") }}
                                </h4>
                            </v-col>
                            <v-col style="height: 28px" cols="12" sm="4" md="4" lg="4">
                                <z-vendor-select v-model="vendor" :selectFirst="true"></z-vendor-select>
                            </v-col>
                            <v-col cols="12" sm="4" md="4" lg="4" style="height: 28px; padding-left: 0px">
                                <z-month-picker style="color: red" :label="''" dense v-model="tillYearMonthVendor" />
                            </v-col>
                        </v-row>
                        <v-row v-if="vendorValue">
                            <v-col>
                                <z-spark-line customLabel="true" :value="vendorValue" :labels="vendorLabel" width="2"
                                    radius="10" lineCap="round" :gradient="vendorGradient"></z-spark-line>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>


</template>

<script>
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { Vue, Component, Watch } from "vue-property-decorator";
@Component({
    name: "SparkSelect",
    props: {
    }
})
export default class SparkSelect extends Vue {
    client = null;
    vendor = null;
    isCLient = false;
    isVendor = false;
    tillYearMonth = null;
    tillYearMonthVendor = null;

    clientGradient = ['#17a2b8'];
    vendorGradient = ['#17a2b8'];

    url = "/api/report/revenue/booking/datapoints"
    clientValue = null;
    vendorValue = null;
    clientLabel = [];
    vendorLabel = [];
    @Watch("client")
    onSelectClient() {
        this.processForClient();
    }
    @Watch("vendor")
    onSelectVendor() {
        this.processForVendor();
    }
    @Watch("tillYearMonth")
    onChangeYearMonthClient() {
        this.processForClient();
    }
    @Watch("tillYearMonthVendor")
    onChangeYearMonthVendor() {
        this.processForVendor();
    }


    async processForClient() {
        let url = this.url;
        try {
            common.setLoading(true);
            if (this.client != null && this.tillYearMonth != null) {

                this.isCLient = true;
                url = url + "?isClient=true&&corp_id=" + this.client;
                url = url + "&&tillYearMonth=" + this.tillYearMonth;
                const value = await doGet(url);
                this.clientValue = value;
            }
            common.setLoading(false);
        } catch (error) {
            common.setLoading(false);
            common.setError(error.message);
        }
        this.fillClientLabels(this.clientValue);
    }

    async processForVendor() {
        let url = this.url;
        try {
            common.setLoading(true);
            if (this.vendor != null && this.tillYearMonthVendor != null) {
                this.isVendor = true;
                url = url + "?isVendor=true&&corp_id=" + this.vendor;
                url = url + "&&tillYearMonth=" + this.tillYearMonth;

                const value = await doGet(url);
                this.vendorValue = value;
            }
            common.setLoading(false);
        } catch (error) {
            common.setLoading(false);
            common.setError(error.message);
        }
        this.fillVendorLabels(this.vendorValue);

    }

    fillClientLabels(vas) {
        if (vas) {
            this.clientLabel = [];
            for (let i = 0; i < vas.length; i++) {
                this.clientLabel.push(vas[i].key + "(" + vas[i].value + ")");
            }
        }
    }


    fillVendorLabels(vas) {
        if (vas) {
            this.vendorLabel = [];
            for (let i = 0; i < vas.length; i++) {
                this.vendorLabel.push(vas[i].key + "(" + vas[i].value + ")");
            }
        }
    }
    setInitialDate() {
        const d = new Date();
        const year = d.getFullYear();
        let month = d.getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        this.tillYearMonth = year + "" + month;
        this.tillYearMonthVendor = year + "" + month;
    }

    async mounted() {
        this.setInitialDate();
    }

}
</script>

<style>
</style>